export const R = {
	"YourNextConsultation": "Din næste konsultation",
	"GoToUpcomingConsultation": "Se aftalen",
	"BackToBookingButtonLabel": "Tilbake til bestilling",
	"SundvaegtGoalCardTitle": "Vektloggen din",
	"SundvaegtGoalCardDescription": "For noen kan det være motiverende å veie seg. Hvis det øker motivasjonen din, kan du følge fremgangen din ved å loggføre vekten jevnlig.",
	"SundvaegtGoalCardActionButtonText": "Sett deg et mål",
	"SundvaegtGoalProgressStartLabel": "Start",
	"SundvaegtGoalProgressEndLabel": "Mål",
	"SundvaegtGoalProgressWeightLabel": "Vekt",
	"SundvaegtSetWeightGoalModalTitle": "Sett deg et mål",
	"SundvaegtSetWeightGoalModalDescription": "Ved å logge vekten din jevnlig kan du følge fremgangen din. Dette kan hjelpe deg å nå målet ditt.",
	"SundvaegtSetWeightGoalModalInputLabel": "Din ønskede målsvekt",
	"SundvaegtSetWeightGoalModalInputRequiredLabel": "Du må fylle inn målvekten din.",
	"SundvaegtSetWeightGoalModalSubmitButton": "Lagre målsvekt",
	"SundvaegtSetWeightGoalModalInfoTitle": "Målsvekten din er for lav",
	"SundvaegtSetWeightGoalModalInfoDescription": "I forhold til høyden din anbefaler vi en vekt over {0} kg. Det tilsvarer en BMI på 18,5 eller høyere.",
	"SundvaegtSetWeightGoalModalValidationWeightGoalTooHigh": "Målvekten din må være lavere enn startvekten din.",
	"SundvaegtSetWeightGoalModalValidationWeightGoalTooLow": "Vennligst oppgi en målsatt vekt over {0} kg.",
	"SundvaegtSetWeightGoalErrorMessage": "Kunne ikke lagre vektmål:",
	"SundvaegtAddWeightLogErrorMessage": "Kunne ikke lagre vektlogg:",
	"SundvaegtEditWeightLogErrorMessage": "Kunne ikke oppdatere vektlogg:",
	"SundvaegtDeleteWeightLogErrorMessage": "Kunne ikke slette vektlogg:",
	"SundvaegtSetWeightGoalInputPlaceholder": "Skriv inn målvekt",
	"SundvaegtProgramConfirmationLabel": "Nå er du i gang med vekttapet ditt!",
	"SundvaegtProgramLogWeightButtonLabel": "Logg vekt",
	"SundvaegtAddWeightLogModalTitle": "Logg vekt",
	"SundvaegtAddWeightLogModalInputLabel": "Vekt",
	"SundvaegtAddWeightLogModalInputRequiredLabel": "Du må fylle inn en vekt.",
	"SundvaegtAddWeightLogModalSubmitButton": "Lagre vekt",
	"SundvaegtAddWeightLogInputPlaceholder": "Skriv inn vekt",
	"SundvaegtWeightLogCardLatestWeightLossLabel": "Vekttap siden sist:",
	"SundvaegtWeightLogCardOverallWeightLossLabel": "Samlet vekttap:",
	"SundvaegtWeightLogCardOverallWeightLossStatus": "Du har gått ned {0} av {1}",
	"SundvaegtWeightLogCardOverallWeightLossStatusPart1": "Du har gått ned",
	"SundvaegtWeightLogCardOverallWeightLossStatusPart2": "av",
	"SundvaegtWeightEditWeightLogLabel": "Rediger vektlogg",
	"SundvaegtWeightDeleteWeightLogLabel": "Slett vektlogg",
	"SundvaegtDateInputLabel": "Dato",
	"SundvaegtDateInputRequiredLabel": "Du må fylle inn en dato.",
	"SundvaegtPleaseEnterValidWeightLabel": "Vennligst skriv inn en gyldig vekt.",
	"SundvaegtWeightLogChartYLabel": "Vekt (kg)",
	"SundvaegtWeightLogChartXLabel": "Måned",
	"SundVaegtChartTooltip": "Dato: {0}, Vekt: {1}",
	"NnSundvaegtConsultationsLeft": "Du har {0} gratis videokonsultationer",
	"NnSundvaegtConsultationsExpire": "Dine gratis konsultationer udløber:",
	"NnSundvaegtAreYouDone": "Har du nået dit vægtmål eller er du stoppet på Wegovy? Her kan du ",
	"NnSundvaegtCancelProgram": "afmelde dig SundVægt Sammen.",
	"SundvaegtFeedbackTitle": "Hjelp oss å bli bedre",
	"SundvaegtFeedbackDescription": "Vi vil gjerne høre om opplevelsen din med SundVægt. Svar på tre korte spørsmål og hjelp oss å forstå hva som fungerer godt, og hvor vi kan bli bedre.",
	"SundvaegtFeedbackButtonLabel": "Besvar spørsmål",
	"EditGoalWeight": "Rediger målvekt",
	"ArticlesHeader": "Utvalgte artikler\n",
	"ShowMore": "Vis mer",
	"ShowLess": "Vis mindre",
	"All": "Alle",
	"MeetTheTeamHeader": "Mød teamet",
	"ArticleNewLabel": "Ny"
}